<template>
  <a-spin :spinning="data.loading">
    <div class="editForm">
      <div class="left">
        <div class="title">检查表单编辑</div>
        <div class="carouselClass">
          <a-carousel arrows ref="varousel">
            <template #prevArrow>
              <div class="custom-slick-arrow" style="left: 10px; z-index: 1">
                <left-circle-outlined />
              </div>
            </template>
            <template #nextArrow>
              <div class="custom-slick-arrow" style="right: 10px">
                <right-circle-outlined />
              </div>
            </template>
            <div v-for="(item, index) in data.imgList" :key="index">
              <auth-img mode="ant" :src="item" :fallback="data.fallbackImg" placeholder />
            </div>
          </a-carousel>
        </div>
      </div>
      <div class="right">
        <div class="top">
          <div class="topButton">
            <a-button type="primary" @click="onSubmit">保存</a-button>
          </div>
        </div>
        <div style="margin: 20px 20px">
          <div>
            <a-form ref="formRef" :rules="data.rules" :model="data.formState" layout="vertical">
              <div class="addBtnDiv">
                <a-button @click="add" class="addBtn z-fixed-c">添加表单</a-button>
              </div>
              <a-tabs
                v-model:activeKey="activeKey"
                type="editable-card"
                @edit="onEdit"
                hide-add
                animated
              >
                <a-tab-pane
                  v-for="pane in data.panes"
                  :key="pane.key"
                  :tab="pane.title ? pane.title : '空白'"
                  :closable="pane.closable"
                >
                  <!-- 如果当前tab对应的值!=='空白'就禁止再次选择 -->
                  <div class="selsecCard z-fixed">
                    <a-select
                      v-model:value="data.selectFormValue"
                      @change="handleChange"
                      placeholder="选择检查单类型"
                      class="topSelect"
                      :disabled="pane.title ? true : false"
                    >
                      <a-select-option
                        v-for="option in data.selectOptions"
                        :disabled="data.isSelectList.includes(option.checklistType) ? true : false"
                        :value="option.checklistType"
                        :key="option.checklistType"
                      >
                        {{ option.checklistName }}
                      </a-select-option>
                    </a-select>
                  </div>
                  <!-- 对应表单 -->
                  <div style="overflow-y: scroll; height: calc(100vh - 300px)">
                    <div style="display: grid; grid-template-columns: 1fr 1fr">
                      <div v-for="(formItem, formIndex) in pane.items" :key="formIndex">
                        <div>
                          <a-form-item
                            :label="formItem.itemName"
                            :name="pane.tabIndex + 'prop_' + formItem.itemId"
                          >
                            <a-input-number
                              v-if="[1, 2].includes(formItem.itemType)"
                              v-model:value="
                                data.formState[pane.tabIndex + 'prop_' + formItem.itemId]
                              "
                              class="formClass"
                              :min="1"
                              :max="formItem.itemType == 2 ? 9999.99 : 9999"
                              @blur="
                                inputR(
                                  $event,
                                  pane.tabIndex + 'prop_' + formItem.itemId,
                                  formItem.itemType
                                )
                              "
                            />
                            <!-- :placeholder="
                              '请选择' + inputSubstring(formItem.itemName)
                            " -->
                            <a-date-picker
                              v-if="formItem.itemType === 3"
                              valueFormat="YYYY-MM-DD"
                              placeholder="选择日期"
                              v-model:value="
                                data.formState[pane.tabIndex + 'prop_' + formItem.itemId]
                              "
                              class="formClass"
                            />
                            <a-input
                              allowClear
                              v-if="[4].includes(formItem.itemType)"
                              v-model:value="
                                data.formState[pane.tabIndex + 'prop_' + formItem.itemId]
                              "
                              class="formClass"
                              :maxlength="60"
                            />
                            <a-textarea
                              allowClear
                              v-if="[5].includes(formItem.itemType)"
                              showCount
                              v-model:value="
                                data.formState[pane.tabIndex + 'prop_' + formItem.itemId]
                              "
                              class="formClass"
                              :maxlength="60"
                            />
                            <a-radio-group
                              v-if="[6].includes(formItem.itemType)"
                              v-model:value="
                                data.formState[pane.tabIndex + 'prop_' + formItem.itemId]
                              "
                            >
                              <a-radio
                                v-for="(radioItem, radioIndex) in formItem.options"
                                :key="radioIndex + 1"
                                :value="String(radioIndex + 1)"
                              >
                                {{ radioItem.optionContent }}
                              </a-radio>
                            </a-radio-group>
                            <span style="margin-left: 10px">
                              {{ formItem.itemUnit ? formItem.itemUnit : '' }}
                            </span>
                          </a-form-item>
                        </div>
                      </div>
                    </div>
                  </div>
                </a-tab-pane>
              </a-tabs>
            </a-form>
            <!-- <div class="addBtn">
              <div class="addFormBtn z-fixed-c" @click="add">添加表单</div>
            </div> -->
          </div>
        </div>
        <!-- 下面表单 -->
      </div>
    </div>
  </a-spin>
</template>
<script>
export default {
  name: 'formEdit'
}
</script>

<script setup>
import {
  LeftCircleOutlined,
  RightCircleOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons-vue'
import { inputRule } from '@/utils/validate'
import {
  reactive,
  ref,
  watch,
  toRaw,
  onMounted,
  onActivated,
  onDeactivated,
  createVNode
} from 'vue'
import { formItemType } from './config.js'
import { message, Modal } from 'ant-design-vue'
import { checklistItemInit, checklistItemFill } from '@/api/HealthRecord/index.js'
import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()
const formRef = ref()
const varousel = ref()
const data = reactive({
  fallbackImg: require('./images/swImg-err.png'),
  loading: true,
  //tab数据
  panes: [{ title: '', key: 0, select: null, items: [], tabIndex: 0 }],
  //最终数据
  resultData: [],
  formState: {},
  //校验
  rules: [],
  newTabIndex: 0,
  // 轮播图数据
  imgList: [],
  // 选择下拉框的 value值
  selectFormValue: null,
  //下拉框选项
  selectOptions: [],
  errorTabs: [],
  checklistId: '',
  formType: formItemType,
  isSelectList: [],
  first: false
})

const activeKey = ref(data.newTabIndex)
// 去除数组对象为空的数据
const trimSpace = array => {
  for (var i = 0; i < array.length; i++) {
    if (array[i] == ' ' || array[i] == null || typeof array[i] == 'undefined') {
      array.splice(i, 1)
      i = i - 1
    }
  }
  return array
}
// 获取数据
const getChecklistItemInit = checklistId => {
  checklistItemInit({ checklistId: checklistId })
    .then(res => {
      if (res && res[0]) {
        data.imgList = res[0].urls
        data.selectOptions = res[0].questions
        //1. 遍历出items里的valueDetail有值的 2.初始化data.formState和data.panes
        // 处理数据
        detailInit(res[0].questions).then(detailRes => {
          if (detailRes.length > 0) {
            data.panes = detailRes
            activeKey.value = data.panes[0].tabIndex
            data.newTabIndex = data.panes[data.panes.length - 1].tabIndex
            console.log('data.panes===', data.panes)
            changeRules()
          } else {
            resetData()
          }
        })
      }
    })
    .finally(() => {
      data.loading = false
    })
}

// 重置数据
const resetData = () => {
  data.panes = [{ title: '', key: 0, select: null, items: [], tabIndex: 0 }]
  data.newTabIndex = 0
  activeKey.value = 0
  data.formState = {}
  data.isSelectList = []
  data.selectFormValue = null
}
// 初始化tab标签数据，初始化详情数据
const detailInit = questions => {
  return new Promise((resolve, reject) => {
    const initTabs = reactive([])
    questions.map((q, index) => {
      let isHaveDetil = reactive({})
      if (q.items.length > 0) {
        //找出items里valueDetail有值的
        isHaveDetil = trimSpace(q.items.map(item => item.valueDetail))
        if (isHaveDetil.length > 0) {
          q.items.map((iItem, iIndex) => {
            iItem[index + 'prop_' + iItem.itemId] = iItem.valueDetail
            data.formState[index + 'prop_' + iItem.itemId] =
              iItem.itemType === 6
                ? iItem.valueSort + ''
                : data.formType[iItem.itemType - 1].type == 'number'
                ? Number(iItem.valueDetail) > 0
                  ? Number(iItem.valueDetail)
                  : null
                : iItem.valueDetail
          })
          initTabs.push({
            title: q.checklistName,
            key: index,
            select: q.checklistType,
            items: q.items,
            tabIndex: index
          })
        }
      }
    })

    resolve(initTabs)
  })
}

onDeactivated(() => {
  window.onbeforeunload = null
  data.imgList = []
  resetData()
})
onMounted(() => {})
onActivated(() => {
  if (route.query) {
    if (route.query.checklistId) {
      //第一次进入默认显示第一个
      varousel.value.goTo(0)
      data.checklistId = route.query.checklistId
      getChecklistItemInit(route.query.checklistId)
    }
  }
  window.onbeforeunload = function (e) {
    return ''
  }
})
//删除提示
const remove = targetKey => {
  Modal.confirm({
    centered: true,
    title: () => '确定删除检查单表吗？',
    icon: () => createVNode(ExclamationCircleOutlined),
    onOk() {
      removeTab(targetKey)
    },
    onCancel() {
      console.log('Cancel')
    }
  })
}

//增加tab标签栏
const add = () => {
  activeKey.value = ++data.newTabIndex
  // 增加一个空的tab数据
  data.panes.push({
    title: '',
    key: activeKey.value,
    select: null,
    items: [],
    tabIndex: activeKey.value
  })
}

//删除标签栏
const removeTab = targetKey => {
  let lastIndex = 0
  data.panes.forEach((pane, i) => {
    if (pane.key === targetKey) {
      lastIndex = i - 1
      // 不要忘记把总mode的数据删除
      pane.items.map(formItem => {
        delete data.formState[pane.tabIndex + 'prop_' + formItem.itemId]
      })
    }
  })
  data.panes = data.panes.filter(pane => pane.key !== targetKey)
  if (data.panes.length && activeKey.value === targetKey) {
    if (lastIndex >= 0) {
      activeKey.value = data.panes[lastIndex].key
    } else {
      activeKey.value = data.panes[0].key
    }
  }
  changeRules()
}
const onEdit = (targetKey, action) => {
  if (action === 'add') {
    add()
  } else {
    remove(targetKey)
  }
}
// 选择下拉框数据，并改造数据
const handleChange = e => {
  const tabs = JSON.parse(JSON.stringify(data.panes))
  data.panes.map((item, index) => {
    if (item.key === activeKey.value) {
      item.title = e ? data.selectOptions[e - 1].checklistName : ''
      item.select = e
      item.tabIndex = activeKey.value
      item.items = JSON.parse(JSON.stringify(data.selectOptions[e - 1].items))
      //校验类型处理
      item.items.map(formItem => {
        formItem[item.tabIndex + 'prop_' + formItem.itemId] =
          data.formType[formItem.itemType - 1].default
      })
    }
  })
  changeRules()
}

//去重
const dedupe = array => {
  return Array.from(new Set(array))
}
const onSubmit = () => {
  const errlist = reactive([])
  changeRules().then(() => {
    formRef.value
      .validate()
      .then(() => {
        //成功之后的数据拼在 data.panes里
        data.panes.map((pane, index) => {
          if (pane.items.length > 0) {
            pane.items.map(formItem => {
              if (formItem) {
                formItem[pane.tabIndex + 'prop_' + formItem.itemId] =
                  data.formState[pane.tabIndex + 'prop_' + formItem.itemId]
              }
            })
          }
        })
      })
      .then(() => {
        //在过滤 reItem.items 为空的数据
        //  data.resultData
        const resultData = JSON.parse(JSON.stringify(data.panes))
        for (let i = resultData.length - 1; i >= 0; i--) {
          if (resultData[i].items.length <= 0) {
            resultData.splice(i, 1)
          } else {
            resultData[i].items.map(formItem => {
              const key = resultData[i].tabIndex + 'prop_' + formItem.itemId
              if (formItem.itemType === 6) {
                // Number(formItem[key]) - 1 是因为单选框是从1开始的，所以根据下标取optionContent 需要-1
                const r =
                  formItem &&
                  formItem.options[Number(formItem[key]) - 1] &&
                  formItem.options[Number(formItem[key]) - 1].optionContent
                formItem.valueDetailUnit = r
                  ? formItem.options[Number(formItem[key]) - 1].optionContent + formItem.itemUnit
                  : ''
                formItem.valueDetail = r
                  ? formItem.options[Number(formItem[key]) - 1].optionContent
                  : ''
                formItem.valueSort = formItem[key] ? Number(formItem[key]) : null
              } else {
                formItem.valueDetail = formItem[key] ? formItem[key] : ''
                formItem.valueDetailUnit = formItem[key] + formItem.itemUnit
              }
            })
          }
        }

        data.resultData = resultData.map(pane => {
          return {
            checklistName: pane.title,
            checklistType: pane.select,
            items: pane.items
          }
        })

        console.log('最终结果', toRaw(data.resultData))
        //对数据进行保存
        saveCheckList(data.resultData)
      })
      .catch(error => {
        console.log('error', error)
        //找出哪些tab页的校验数据还没有填写，就跳到没有校验的第一个tab
        error.errorFields.map(errorItem => {
          const index = errorItem.name[0].lastIndexOf('prop_')
          errlist.push(Number(errorItem.name[0].substring(0, index)))
        })
        data.errorTabs = dedupe(errlist)
        console.log('未校验的tab集合==', data.errorTabs)
        //跳转没有校验的tab
        activeKey.value = data.errorTabs[0]
      })
  })
}

const saveCheckList = resultData => {
  const params = {
    checklistList: resultData,
    editName: '',
    id: data.checklistId
  }
  checklistItemFill(params).then(res => {
    router.go(-1)
    message.success('保存成功')
  })
}

// 校验为正整数内容和必填项
const checkData = async (rule, value) => {
  if (!value) {
    rule.message = '请输入内容'
    return Promise.reject(rule.message)
  }
  checkInt(rule, value)
}
// 校验为正整数内容
const checkInt = async (rule, value) => {
  if (value) {
    if (!Number.isInteger(value)) {
      rule.message = '请输入正整数'
      return Promise.reject(rule.message)
    }
  }
}

//添加校验
const changeRules = () => {
  data.isSelectList = []
  return new Promise(resolve => {
    const ruleObj = reactive({})
    data.panes.map((pane, index) => {
      data.isSelectList.push(pane.select)
      pane.items.map(formItem => {
        const rule = {
          required: formItem.requiredFlag == '1' ? true : false,
          message:
            (formItem.itemType === 6 ? '请选择' : '请输入') +
            inputSubstring(formItem.itemName) +
            (formItem.itemType === 4 ? '(最多60个字)' : ''),
          trigger: ['change', 'blur'],
          type: data.formType[formItem.itemType - 1].type,
          validator:
            formItem.itemType === 1 ? (formItem.requiredFlag == '1' ? checkData : checkInt) : ''
        }
        //validator 当为必填项的时候检验既是必填项也是正整数；当不是必填项时，检验为正整数
        return (ruleObj[pane.tabIndex + 'prop_' + formItem.itemId] = rule)
      })
    })
    data.rules = ruleObj
    console.log('data.rules ===', data.rules)
    resolve()
  })
}
const inputSubstring = e => {
  return e.substring(e.lastIndexOf('、') + 1, e.length)
}
//控制输入规则
const inputR = (e, key, type) => {
  //保留两位小数
  if (type == 2) {
    if (e.target.value) {
      data.formState[key] = inputRule(e.target.value, 2)
    }
    changeRules()
  }
}

watch(
  () => activeKey.value,
  key => {
    data.panes.map(item => {
      if (item.key === key) {
        data.selectFormValue = item.select
      }
    })
  },
  { immediate: true }
)
</script>
<style scoped lang="scss">
.editForm {
  display: flex;
  position: relative;
  .addBtnDiv {
    float: right;
    ::v-deep(.ant-btn) {
      border-radius: 4px;
      padding: 0;
      line-height: 0;
      width: 80px;
      height: 28px;
      border-color: #999999;
    }
    // .addBtn {
    //   width: 80px;
    //   height: 28px;
    //   border: 1px solid #999999;
    //   border-radius: 4px;
    //   font-size: 14px;
    //   color: #666666;
    // }
  }
  .right {
    width: 50%;
    height: 100vh;
    background: #ffffff;
    position: relative;
    // ::v-deep(.ant-form-item) {
    //   margin-bottom: 16px;
    // }

    .formClass {
      width: 180px;
    }
    .selsecCard {
      height: 60.5px;
      position: relative;
      .topSelect {
        width: 314px;
      }
      .delButton {
        position: absolute;
        right: 20px;
      }

      ::v-deep(.ant-btn-link) {
        color: #1890ff;
        font-weight: bold;
        font-size: 14px;
      }
      ::v-deep(.ant-btn) {
        padding: 0;
      }
    }
    .breadcrumbCard {
      padding: 0 20px;
      height: 55px;
      background: rgba(24, 144, 255, 0.03);
      font-weight: bold;
      font-size: 14px;
      .noData {
        color: #1890ff;
      }
    }
    .top {
      display: flex;
      height: 54px;
      align-items: center;
      position: relative;
      padding: 0 20px;
      border-bottom: 1px solid rgba(232, 232, 232, 0.5);
      .topButton {
        position: absolute;
        right: 20px;
        // ::v-deep(.ant-btn-link) {
        //   color: #1890ff;
        //   font-weight: bold;
        //   font-size: 14px;
        // }
        // ::v-deep(.ant-btn) {
        //   padding: 0;
        //   padding-left: 44px;
        // }
      }
    }
  }
  .left {
    width: 50%;
    height: 100vh;
    background: #fafafa;
    position: relative;
    border-right: 1px solid #e8e8e8;
    ::v-deep(.ant-image-img) {
      width: 100%;
      height: 692px;
      object-fit: cover;
    }
    .title {
      height: 54px;
      font-family: PingFangSC-Medium;
      font-weight: bold;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 54px;
      padding-left: 24px;
      background: #ffffff;
      border-bottom: 1px solid rgba(232, 232, 232, 0.5);
    }
    .carouselClass {
      margin: 15.5px 25px 74.5px 25px;
    }
  }
}
.ant-carousel :deep(.slick-dots li.slick-active button) {
  width: 40px;
  height: 6px;
  background: #1890ff;
  border-radius: 4px;
  opacity: 1;
}

.ant-carousel :deep(.slick-dots li button) {
  width: 20px;
  height: 6px;
  opacity: 0.3;
  background: #999999;
  border-radius: 4px;
}
.ant-carousel :deep(.slick-dots) {
  height: 6px;
}
.ant-carousel :deep(.slick-dots-bottom) {
  bottom: -16px;
}
// 轮播图大小样式
.ant-carousel :deep(.slick-slide) {
  text-align: center;
  max-height: 692px;
  overflow: hidden;
}
// 轮播图箭头的样式
.ant-carousel :deep(.slick-arrow.custom-slick-arrow) {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
  border-radius: 50%;
}
// 隐藏原来的箭头
.ant-carousel :deep(.custom-slick-arrow:before) {
  display: none;
}
.ant-carousel :deep(.custom-slick-arrow:hover) {
  opacity: 0.5;
}
</style>
